import gql from "graphql-tag";

export const CHATS_TOKEN = gql`
  mutation chatsToken {
    chatsToken {
      token
    }
  }
`;

export const AGENT_PROFILE = gql`
  query agentProfile($id: ID!) {
    agentProfile(id: $id) {
      userInfo {
        id
        firstName
        lastName
        avatar
        phone
        email
        role
        aboutMe
      }
    }
  }
`;

export const BUYER_PROFILE = gql`
  query buyerProfile($id: ID!) {
    buyerProfile(id: $id) {
      userInfo {
        id
        firstName
        lastName
        phone
        email
        role
        avatar
        aboutMe
      }
    }
  }
`;

export const PLACES_SUGGESTIONS = gql`
  query GetSuggestions($address: String!) {
    places(input: $address) {
      type
      places {
        description
        placeId
      }
    }
  }
`;

export const CREATE_DEAL = gql`
  mutation createDeal(
    $channelSid: ID!
    $location: String!
    $date: String!
    $price: Int!
  ) {
    createDeal(
      channelSid: $channelSid
      location: $location
      date: $date
      price: $price
    ) {
      status
    }
  }
`;

export const CREATE_USER_REPORT = gql`
  mutation createUserReport($channelSid: ID!, $text: String!) {
    createUserReport(channelSid: $channelSid, text: $text) {
      status
    }
  }
`;
